import React from 'react'

const AdminDashboard: React.FC = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900">Admin Dashboard</h1>
      <p className="text-gray-600 mt-2">Administrative functions here.</p>
    </div>
  )
}

export default AdminDashboard
